import * as React from "react"
import Container from "@mui/material/Container"
import Box from "@mui/material/Box"

import Logo from "components/Logo"

export default function PageLoader({ height = 350 }: { height: number }) {
  return (
    <Container>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={height}
      >
        <Logo width="94px" height="40px" animate={true} />
      </Box>
    </Container>
  )
}
